import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://user-images.githubusercontent.com/81949743/131253226-bbd5fc26-fcc7-4ce4-a4da-937dc6a2a784.png"
              isBlog={false}
              title="Clone of strawberrynet.com"
              description=" The Project is an E-commerce website that has a brand filter, sorting of products, Search Functionality, and User Authentication.
                           The Tech Stack used is HTML, CSS, Javascript, Node, and MongoDB"
              link="https://github.com/MohitMaurya/re-clone-strawberrynet"
              deploy="https://strawberrynet-clone-frontend.vercel.app/"
              bloglink="https://medium.com/@akhil_fw10_030/our-team-experience-of-building-clone-of-strawberrynet-com-8b7d74f060e0"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://mohit-maurya.vercel.app/static/media/home.png.1b81de5a.png"
              isBlog={false}
              title="Clone of boat-lifestyle.com"
              description="The Project is an E-commerce website of boat-lifestyle which has sorting of products and User Authentication.
              The Tech Stack used JavaScript, ReactJS, NodeJS, Express, and MongoDB"
              link="https://github.com/MohitMaurya/Boat-Lifestyle-Clone-v2"
              deploy="https://boat-lifestyle-clone.vercel.app/"
              bloglink="https://medium.com/@mohit-maurya/cloning-of-www-boat-lifestyle-com-our-first-project-with-ui-ux-team-6272f6a69144"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
